export default __webpack_public_path__ + "static/media/5.954788d5.jpg";